// extracted by mini-css-extract-plugin
export default {"projectTitleSection":"_8xqc2pb2x7LvHOcTubl47","projectTitle":"_2F3ty8wJG3eGf12HDIZz6n","displayProjects":"EgX-6dwiDIMhtYsUIds31","envTypeSpan":"XAyW9ND7Juh9V8Ah2Sdeu"};